<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-beige" style="height: 100vh; height: var(--doc-height);">
    <CoreHeader/>
    <v-main>
      <Main
          v-if="$route.name === names.MAIN"
      />
      <router-view v-else />
    </v-main>
  </v-container>
</template>

<script>
// eslint-disable-next-line
import store from '@/store'
import names from '@/modules/core/routers/names'
import Main from "@/modules/core/Main.vue"
import CoreHeader from "@/modules/core/components/CoreHeader.vue"

export default {
  name: 'Base',
  components: {
    CoreHeader,
    Main,
  },
  data () {
    return {
    }
  },
  computed: {
    names () {
      return names
    }
  },
  methods: {
    documentHeight () {
      const doc = document.documentElement
      doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }
  },
  mounted () {
    window.addEventListener("resize", this.documentHeight)
    this.documentHeight()
  },
  unmounted () {
    window.removeEventListener("resize", this.documentHeight)
  },

}
</script>

<style scoped>
:root {
  --doc-height: 100vh;
}
</style>
